import {
  type Permissions,
  type IPermissionsContactAccess,
  type EnumUserRoles,
} from 'entities/Users'
import { type IResponsePermissions, type IRolePermissionsData } from '../api/types'
import { PERMISSION_KEYS } from './permissionsConfig'

export function checkIsCustomPermission(
  key: keyof Permissions,
  userPermissions: Permissions,
  rolePermissionsData: IRolePermissionsData | null,
  contactAccessValue?: IPermissionsContactAccess | null
): boolean {
  const organizationPermissions = rolePermissionsData?.organization_permissions
  const unavailablePermissions = rolePermissionsData?.unavailable_permissions

  if (!organizationPermissions) return false

  if (unavailablePermissions?.some((item) => item.key === key)) {
    return false
  }

  const permissionConfig = organizationPermissions[key]
  if (!permissionConfig || !('default' in permissionConfig)) return false

  if (contactAccessValue) {
    return (
      userPermissions.contactAccess !== organizationPermissions.contactAccess.default &&
      userPermissions.contactAccess === contactAccessValue
    )
  }

  if (key === 'contactAccess') {
    return userPermissions.contactAccess !== organizationPermissions.contactAccess.default
  }

  return userPermissions[key] !== permissionConfig.default
}

export function checkHasCustomPermissions(
  userPermissions: Permissions | null,
  userRole: EnumUserRoles,
  rolePermissions: IResponsePermissions | null
): boolean {
  if (!userPermissions) return false

  const rolePermissionsData = rolePermissions?.[userRole] ?? null

  return PERMISSION_KEYS.some((key) =>
    checkIsCustomPermission(key, userPermissions, rolePermissionsData)
  )
}
